import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '@/components/Layout';
import { protectedRoutes } from '@/routes';
// import { useAuth } from '@/components/Authenticate';
import { useEffect } from 'react';
import { mixPanelServiceInstance } from './analytics/mixpanel';
import AuthGuard from './AuthGuard';

function App() {
  // const { user } = useAuth();
 
  useEffect(() => {
    //Initializing Mix Panel Analytics service
    mixPanelServiceInstance.init();
  }, []);



  const router = createBrowserRouter([
    {
      element: <AuthGuard>
      {({ userInfo, userPermissions }) => (
        <Layout userInfo={userInfo} userPermissions={userPermissions} protectedRoutes />
      )}
    </AuthGuard>,
      children: protectedRoutes,
    },
    {
      element: <AuthGuard>{({ userInfo, userPermissions }) => <Layout userInfo={userInfo} userPermissions={userPermissions} />}</AuthGuard>,
      children: protectedRoutes,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
